import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const userPracticeServicesApi = createApi({
  reducerPath: "userPracticeServices",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getStudioServices: builder.query({
      query: (studioId) => ({
        url: `/studios/${studioId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getAllServices: builder.query({
      query: () => ({
        url: `/practiceservices`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getServiceGroup: builder.query({
      query: (studioId) => ({
        url: `/UserPracticeServiceCategory/${studioId ? `?studioId=${studioId}` : ''}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const { useGetStudioServicesQuery, useGetAllServicesQuery, useGetServiceGroupQuery } = userPracticeServicesApi;
